import {UniqueIdentifier} from '@dnd-kit/core';

import {DashboardTileCoordinates} from '../types/DashboardTileCoordinates';

const GAP_SLOT_ID_PATTERN = /^gap:(\d+):(\d+)$/;

// Reads the droppable id built by toDashboardGapSlotId; tile ids and anything else give null.
export function parseDashboardGapSlotId(id: UniqueIdentifier): DashboardTileCoordinates | null {
  const parsed = GAP_SLOT_ID_PATTERN.exec(id.toString());

  if (parsed === null) {
    return null;
  }

  return {column: Number(parsed[1]), row: Number(parsed[2])};
}
